/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageWearPointResponse
 */
export interface UndercarriageWearPointResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageWearPointResponse
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearPointResponse
     */
    undercarriageHours?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearPointResponse
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearPointResponse
     */
    targetPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearPointResponse
     */
    measurement?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageWearPointResponse
     */
    unitSymbol?: string;
}

/**
 * Check if a given object implements the UndercarriageWearPointResponse interface.
 */
export function instanceOfUndercarriageWearPointResponse(value: object): value is UndercarriageWearPointResponse {
    return true;
}

export function UndercarriageWearPointResponseFromJSON(json: any): UndercarriageWearPointResponse {
    return UndercarriageWearPointResponseFromJSONTyped(json, false);
}

export function UndercarriageWearPointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageWearPointResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'undercarriageHours': json['undercarriageHours'] == null ? undefined : json['undercarriageHours'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'targetPercentage': json['targetPercentage'] == null ? undefined : json['targetPercentage'],
        'measurement': json['measurement'] == null ? undefined : json['measurement'],
        'unitSymbol': json['unitSymbol'] == null ? undefined : json['unitSymbol'],
    };
}

export function UndercarriageWearPointResponseToJSON(json: any): UndercarriageWearPointResponse {
    return UndercarriageWearPointResponseToJSONTyped(json, false);
}

export function UndercarriageWearPointResponseToJSONTyped(value?: UndercarriageWearPointResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'undercarriageHours': value['undercarriageHours'],
        'percentage': value['percentage'],
        'targetPercentage': value['targetPercentage'],
        'measurement': value['measurement'],
        'unitSymbol': value['unitSymbol'],
    };
}

